import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const meditationSteps = [
  {
    number: 1,
    title: 'Find a Comfortable Position',
    description: 'Sit or lie down in a quiet place. Keep your back straight but not stiff. You can use a cushion for support.'
  },
  {
    number: 2,
    title: 'Close Your Eyes Gently',
    description: 'Allow your eyelids to rest without force. This helps in turning your focus inward and minimizing distractions.'
  },
  {
    number: 3,
    title: 'Focus on Your Breath',
    description: 'Notice the sensation of air entering your nostrils and filling your lungs. Feel your belly rise and fall with each breath.'
  },
  {
    number: 4,
    title: 'Acknowledge Thoughts',
    description: 'Your mind will wander. When it does, gently acknowledge the thought without judgment and guide your focus back to your breath.'
  }
];

const MorningMeditationSession1: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Morning Meditation Session 1',
      description: 'Completed Morning Meditation Session 1.',
      image: require('../assets/meditation.png').default || require('../assets/meditation.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/morning-meditation');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 1: Mindful Breathing</h1>
              <p className="session-description">
                Follow along with the video and use the instructions on the right for guidance. Focus on your breath and be present in the moment.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/inpok4MKVLM"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Meditate</h2>
                <div className="session-steps">
                  {meditationSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MorningMeditationSession1;

